import { Buttons, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import Trans from 'Components/Trans';
import { WHATSAPP_CONTACT_LINK } from 'Config';
import { openUrlInNewNavigator } from 'Utils/links';
import * as Styled from './styles';

const ContactLink = WHATSAPP_CONTACT_LINK || '';

const Contact = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.PLANS);
  return (
    <>
      <Text type="paragraphs" color="grey" size="M_L_S" mt="fds_size_32" mb="fds_size_16">
        <Trans
          i18nKey={t('Plans.contact')}
          components={{
            a: <Styled.Link target="_blank" />,
          }}
          ns="plans"
        />
      </Text>
      <Buttons.Contextual
        label={t('Plans.contact.label')}
        mode="primary"
        onClick={() => openUrlInNewNavigator(ContactLink)}
      />
    </>
  );
};

export default Contact;
